import React from 'react'

import { getLocale, setLocale } from '../../../utils/locale/locale'
import TabsMenu, { Tab } from '../../../components/tabs/TabsMenu'
import { COLORS } from '@btime/constants'

const LocalLink = ({ label, lng }) => {
  const active = getLocale() === lng

  return (
    <Tab
      color={active ? COLORS.purple : COLORS.dark3}
      active={active}
      onClick={() => setLocale(lng)}
      fullWidth
      size="small"
    >
      {label}
    </Tab>
  )
}

const LangChanger = () => {
  return (
    <TabsMenu>
      <LocalLink label="Português" lng="pt" />
      <LocalLink label="English" lng="en" />
    </TabsMenu>
  )
}

export default LangChanger
